import { Account } from '@zapier/upsells/src/types';
import { accountHasReachedPercentageOfTaskLimit } from '@zapier/upsells/src/utils';

type Props = {
  account: Account | undefined;
};

export const getTaskUpgradeNudgeEligibility = ({ account }: Props) => {
  if (!account) {
    return {
      isEligibleForLowTaskUpgradeNudge: false,
      isEligibleForTaskUpgradeNudge: false,
    };
  }

  const accountHasMeteredBilling = account?.plan?.hasMeteredBilling;
  const currentUserRole = account?.currentUserRole;
  const taskBufferMultiplier = account?.taskBufferOverride ?? 1;
  const taskLimit = account?.usage?.tasks?.limit ?? 0;
  const tasksUsed = account?.usage?.tasks?.total ?? 0;

  const hasReachedLowTaskThreshold = accountHasReachedPercentageOfTaskLimit({
    percentage: 0.8,
    taskBufferMultiplier,
    taskLimit,
    tasksUsed,
  });

  const hasReached100PercentTaskLimit = accountHasReachedPercentageOfTaskLimit({
    percentage: 1,
    taskBufferMultiplier,
    taskLimit,
    tasksUsed,
  });

  const isAutoUpgradeEnabled = Boolean(
    account?.featureEnrollmentList?.find(
      feature => feature?.featureName === 'AUTO_UPGRADE'
    )?.isEnrolled
  );

  const isEligibleForLowTaskUpgradeNudge =
    hasReachedLowTaskThreshold &&
    currentUserRole !== 'member' &&
    !accountHasMeteredBilling &&
    !hasReached100PercentTaskLimit; // to avoid showing both nudges

  const isEligibleForTaskUpgradeNudge =
    hasReached100PercentTaskLimit &&
    currentUserRole !== 'member' &&
    !accountHasMeteredBilling &&
    !isAutoUpgradeEnabled;

  return {
    isEligibleForLowTaskUpgradeNudge,
    isEligibleForTaskUpgradeNudge,
  };
};
